var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"fill":"currentColor","viewBox":"0 0 24 24"}},[_c('path',{attrs:{"d":"M21 3H2V16H21V3M2 17H6V21H2V17M7 17H11V21H7V17M12 17H16V21H12V17M17 17H21V21H17V17Z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }